import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import System from '../../components/administration/system_and_sub_system/system'
import SubSystem from '../../components/administration/system_and_sub_system/sub_system'

const SystemAndSubSystem = () => {
  return (
    <Tabs variant="fullWidth" style={{ width: '100%' }}>
      <TabList style={{ fontSize: '1.25rem' }}>
        <Tab>System</Tab>
        <Tab>Sub System</Tab>
      </TabList>
      <TabPanel>
        <System />
      </TabPanel>
      <TabPanel>
        <SubSystem />
      </TabPanel>
    </Tabs>
  )
}

export default SystemAndSubSystem
